import React, { useContext } from "react"
import contextGeomedellin from "../../../context/contextGeomedellin"
import PiePagina from "../piePagina/PiePagina"
import { Container } from "react-bootstrap"
import Migas from "../migasGeomedellin/Migas"

export default function ComponentGeneric({ idComponente, infoComponent }) {

    const { componentes } = useContext(contextGeomedellin)

    return (
        <>
            <Container fluid={true} className='content-componentgeneric'>
                <div className="sin-img">
                    <div className="content-degradado">
                        <div className="content-contendido-img-banner">
                            <label className="lblitulo-txt-imgbanner">{infoComponent.find(obj => obj.id_componente === idComponente).nombre_componente}</label>
                            <p>
                                <label className="lbdescripcion-txt-imgbanner">Descripción corta y amigable para sección</label>
                            </p>
                        </div>
                    </div>
                    <label className="color-borde-img-banner"></label>
                </div>
                {/* <div>
                    <h1>{infoComponent.find(obj => obj.id_componente === idComponente).nombre_componente}</h1>
                </div> */}
            </Container>
            <Migas ruta={infoComponent.find(obj => obj.id_componente === idComponente).nombre_componente} />
            <PiePagina />
        </>
    )
}